import { render, staticRenderFns } from "./PersonalList.vue?vue&type=template&id=054c26dd&scoped=true&"
import script from "./PersonalList.vue?vue&type=script&lang=js&"
export * from "./PersonalList.vue?vue&type=script&lang=js&"
import style0 from "./PersonalList.vue?vue&type=style&index=0&id=054c26dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c26dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VChip,
})
